import cn from 'classnames'
import { FC, useMemo } from 'react'

import { FormSwitch, useGetFormDataField } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations'
import { Tooltip } from 'core-components/library/tooltip'

import { TRANSLATION_KEYS } from './translations'

import styles from './ApplicableToggle.module.scss'

interface IApplicableFieldProps {
  isEditMode: boolean
  formKey: string
  field: string
  defaultValue: boolean
  containerClassName?: string
  isHideLabel?: boolean
  onChange?: (newValue: boolean) => void
}

export const ApplicableToggle: FC<IApplicableFieldProps> = ({
  field,
  formKey,
  defaultValue,
  containerClassName,
  isEditMode,
  isHideLabel,
  onChange,
}) => {
  const [isApplicable] = useGetFormDataField(formKey, field)

  const applicableTranslationKey = useMemo(() => {
    return isApplicable ? TRANSLATION_KEYS.applicable : TRANSLATION_KEYS.notApplicable
  }, [isApplicable])

  const formSwitchLabel = useMemo(() => {
    return isHideLabel ? '' : applicableTranslationKey
  }, [applicableTranslationKey, isHideLabel])

  return (
    <div
      className={cn(containerClassName, {
        [styles.hide]: !isEditMode && defaultValue,
      })}
    >
      {isEditMode && (
        <Tooltip
          tipContent={() => <Translation text={applicableTranslationKey} span />}
          disabled={!isHideLabel}
        >
          <FormSwitch
            formKey={formKey}
            field={field}
            defaultValue={defaultValue}
            className={styles.input}
            label={formSwitchLabel}
            onChange={onChange}
          />
        </Tooltip>
      )}

      {!isEditMode && !isApplicable && (
        <div className={styles.label}>
          <Translation span text={TRANSLATION_KEYS.notApplicable} />
        </div>
      )}
    </div>
  )
}
